import React, { Component } from "react";

class CalculatorGridCard extends Component {
  render() {
    console.log("CalculatorGridCard props", this.props);
    const formatCurrency = (amount) => `LKR ${Number(amount).toLocaleString()}`;
    return (
      <div
        class="text-center center-block"
        style={{
          paddingTop: "25px",
          paddingBottom: "25px",
          paddingLeft: "40px",
          paddingRight: "40px",
          border: "1px solid #000000",
          borderColor: this.props.borderColor || "#000000",
          marginLeft: "auto",
          marginRight: "auto",
          width: "100%",
          maxWidth: "240px",
          borderRadius: "5px",
          boxShadow: this.props.boxShadow || "0 3px 5px 1px rgba(0,0,0,0.2)",
          backgroundColor: this.props.backgroundColor,
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: 600 }}>
          {this.props.title}
        </div>
        <div
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: this.props.numberColor || "rgba(25, 179, 40, 1)",
          }}
        >
          {formatCurrency(this.props.calculateFunction) || "LKR 0"}
        </div>
      </div>
    );
  }
}

export default CalculatorGridCard;
